import { Box } from 'shared/mui/Box';
import { Button } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog } from 'shared/mui/Dialogs';
import { Typography } from 'shared/mui/Typography';

type Props = {
  error: any;
  open: boolean;
  onClose: () => void;
};

export const RequestsBankOpsImportErrorDialog: React.FC<Props> = ({ open, onClose, error }) => {
  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <CardHeader title="Результаты проверки файла" titleSize="smallBold" />
      <CardContent>
        <Box>
          <Typography variant="body1">
            {error?.data?.errors?.[0].title || 'Что-то пошло не так. Повторите запрос позже.'}
          </Typography>
        </Box>
      </CardContent>
      <CardActionsButtons
        rightActionsSlot={[
          <Button key="cancel" label="Закрыть" onClick={onClose} variant="outlined" />,
        ]}
      />
    </Dialog>
  );
};
